<template>
  <div id="app">
    <BuyEggsPage></BuyEggsPage>
  </div>
</template>

<script>
import BuyEggsPage from '../components/BuyEggsPage.vue'

export default {
  name: 'BuyEggs',
  components: {
    BuyEggsPage
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
